import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

const store = createStore(
  rootReducer,
  composeWithDevTools(applyMiddleware(thunk)),
);

// const store = configureStore({
//     reducer: rootReducer,
//     middleware: [thunk],
//     devTools: process.env.NODE_ENV !== 'production',
//     preloadedState: {},
//     enhancers: [],
// })

export default store;
